import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import InputAdornment from '@material-ui/core/InputAdornment';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import Collapse from '@material-ui/core/Collapse';
import CircularProgress from '@material-ui/core/CircularProgress';
import TablePagination from '@material-ui/core/TablePagination';
import 'moment/locale/pt-br';
import { instanceAxios } from '../../InstanceAxios';
import environment from '../../environment';
import { XMEI_PRIMARY_COLOR } from '../../consts/common';
import { formatMoney } from '../../utils/common';
import HeadTable from '../../components/HeadTable';

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  loading: {
    marginLeft: '50%',
  },
});

function Receita(props) {
  const classes = useStyles();
  const [lancamentos, setLancamentos] = useState([]);
  const [busca, setBusca] = useState('');
  const [ready, setReady] = useState(false);
  const [page, setPage] = React.useState(0);
  const [columns, setcolumns] = useState([
    { id: 'id', label: '#', minWidth: 60 },
    { id: 'descricao', label: 'Descrição', minWidth: 180 },
    { id: 'valor', label: 'Valor', minWidth: 60 },
    { id: 'data_lancamento', label: 'Data Lançamento', minWidth: 80 },
    { id: 'nome', label: 'Cliente', minWidth: 140 },
  ]);
  const [count, SetCount] = useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [campoOrdenacao, setCampoOrdenacao] = useState('');
  const [ordem, setOrdem] = useState('');

  const atualizarLancamentos = async (
    buscaDigitada,
    limit,
    offset,
    cmpOrd,
    ord
  ) => {
    setReady(false);
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post(
        `${environment}/listarLancamentosReceita?campoOrdenacao=${cmpOrd}&ordem=${ord}`,
        {
          id: localStorage.getItem('idadmin'),
          limit,
          offset,
          busca: buscaDigitada,
        }
      )
      .then((res) => {
        setLancamentos(res.data.rows);
        SetCount(res.data.count);
        setReady(true);
      })
      .catch((err) => {
        console.log(err);
        setLancamentos([]);
        SetCount(0);
        setReady(true);
      });
  };

  const handleBusca = (event) => {
    setBusca(event.target.value);
    atualizarLancamentos(
      event.target.value,
      rowsPerPage,
      page,
      campoOrdenacao,
      ordem
    );
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    atualizarLancamentos(
      busca,
      rowsPerPage,
      event.target.value,
      campoOrdenacao,
      ordem
    );
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    atualizarLancamentos(busca, event.target.value, 0, campoOrdenacao, ordem);
  };

  const handleCampoOrdenacao = (co) => {
    let o;
    // Checando se é o mesmo atual
    if (co === campoOrdenacao) {
      o = ordem === 'asc' ? 'desc' : 'asc';
      setOrdem(o);
    } else {
      o = 'asc';
      setOrdem(o);
      setCampoOrdenacao(co);
    }

    atualizarLancamentos(busca, rowsPerPage, page, co, o);
  };

  useEffect(() => {
    atualizarLancamentos('', 5, 0, campoOrdenacao, ordem);
  }, []);

  return (
    <div style={{ margin: 20 }}>
      <h1 style={{ textAlign: 'center' }}>Lançamentos</h1>
      <Paper className={classes.root}>
        <Collapse in={ready}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              padding: 10,
            }}
          >
            <Button
              variant="contained"
              style={{
                backgroundColor: XMEI_PRIMARY_COLOR,
                color: '#FFF',
              }}
              startIcon={<AddIcon />}
              onClick={() => props.history.push(`/lancamentoReceita`)}
            >
              Novo
            </Button>
            <TextField
              id="busca"
              label="Busca"
              value={busca}
              onChange={handleBusca}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <HeadTable
                order={ordem}
                idOrder={campoOrdenacao}
                columns={columns}
                setIdOrder={handleCampoOrdenacao}
              />
            </TableHead>
            <TableBody>
              {lancamentos.map((l) => {
                return (
                  <TableRow key={l.id}>
                    <TableCell component="th" scope="row">
                      {l.id}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {l.descricao}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {formatMoney(l.valor)}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {l.data_lancamento}
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {l.ClienteFinal ? l.ClienteFinal.nome : ''}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={count}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </Collapse>
        <Collapse in={ready === false}>
          <CircularProgress className={classes.loading} />
        </Collapse>
      </Paper>
    </div>
  );
}

export default Receita;
